// import { siteConfig } from '@/configs/siteConfig';

const props = {
  targetClass: 'js-editor',
  classIframeWrap: 'c-iframe',
} as const;

// const state = {};

export const wpEditor = {
  init() {
    this.wrapIframe();
  },

  wrapIframe() {
    const editorEls = document.querySelectorAll<HTMLElement>(`.${props.targetClass}`);

    editorEls.forEach((editorEl) => {
      const iframeEls = editorEl.querySelectorAll<HTMLIFrameElement>('iframe');
      if (iframeEls.length === 0) return;

      iframeEls.forEach((iframeEl) => {
        const parentEl = iframeEl.parentElement;
        if (!(parentEl instanceof HTMLElement)) return;
        if (parentEl.classList.contains(props.classIframeWrap)) return;

        const wrapEl = document.createElement('div');
        wrapEl.classList.add(props.classIframeWrap);

        parentEl.insertBefore(wrapEl, iframeEl);
        wrapEl.appendChild(iframeEl);
      });
    });
  },
};
